const state = {
  isLogin: false, // 是否登陆
  userInfo: {}, // 用户信息
  companyInfo: {}, // 租户信息
  tokenTimeout: 0,
  tenantId: 0,
  chatNum: 0,
  cart: [], // 购物车
  classification: [], // 分类
  ossFileUrl: '', // 图片来源拼接地址
  userColumnsSetting: {
    listSetting: [], // 列设置
    searchSetting: [], // 搜索设置
    isSearchHidden: 0 // 搜索是否隐藏搜条件设置
  }
}

export default state
